import { getImageProp } from '../../../../../../common/elements/utils/elementPropertyUtils';
import type { ImMNElement, MNImageContent } from '../../../../../../common/elements/elementModelTypes';
import { getOriginalImage } from '../../imageModalUtils';

export type ImageModalEditorSourceIdentity = {
    elementId: string;
    imageType: string;
    url?: string;
    usesOriginalSource: boolean;
};

/** Selects the edited display render outside Crop and the canonical full source while Crop is active. */
export const getImageModalEditorSource = ({
    element,
    fullSourceVariant,
    useOriginalSource,
}: {
    element: ImMNElement;
    fullSourceVariant?: MNImageContent;
    useOriginalSource: boolean;
}): MNImageContent =>
    useOriginalSource ? fullSourceVariant || getOriginalImage(element) : (getImageProp(element) as MNImageContent);

/** A same-coordinate source replacement, such as with/without-background, can retain live Cropper data. */
export const isImageModalEditorVariantSwap = (
    previous: ImageModalEditorSourceIdentity | null,
    next: ImageModalEditorSourceIdentity,
): boolean =>
    !!previous &&
    previous.elementId === next.elementId &&
    previous.usesOriginalSource === next.usesOriginalSource &&
    previous.url !== next.url;

/** A Crop toggle changes between edited-image-relative and full-source coordinate spaces. */
export const isImageModalEditorSourceModeSwap = (
    previous: ImageModalEditorSourceIdentity | null,
    next: ImageModalEditorSourceIdentity,
): boolean =>
    !!previous &&
    previous.elementId === next.elementId &&
    previous.imageType === next.imageType &&
    previous.usesOriginalSource !== next.usesOriginalSource;
